package ru.it_mozaika.sender.js.application.context

import io.ktor.client.call.*
import io.ktor.client.statement.*
import io.ktor.http.*
import js.core.jso
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import mui.material.*
import mui.system.responsive
import mui.system.sx
import mui.icons.material.CheckCircle
import mui.icons.material.ErrorOutline
import react.*
import web.cssom.AlignItems
import web.cssom.px

external interface RequestResultProps {
    var show: () -> Unit
    var hide: () -> Unit
    var handleRequestRespond:(HttpResponse) -> Unit
    var onSuccess:(HttpStatusCode) -> Unit
    var messageHandler: (List<String>) -> Unit

}
val RequestResultContext = createContext<RequestResultProps>(
    jso{
        show = {}
        hide = {}
        handleRequestRespond = {}
        onSuccess = {}
        messageHandler = {}

    }
)

val RequestResultProvider = FC<PropsWithChildren>{ props ->

    val (success, setSuccess) = useState<Boolean>()
    val (message, setMessage) = useState<List<String>>(listOf())
    val (isOpen, setIsOpen) = useState(false)

    RequestResultContext.Provider{
        value = jso{
            show = {
                setIsOpen(true)
            }
            hide = {
                setIsOpen(false)
            }
            onSuccess = {status ->
                setSuccess(status == HttpStatusCode.OK)
            }
            messageHandler = {  newMessage ->
                setMessage(newMessage)
            }
            handleRequestRespond = {response ->
                setIsOpen(true)
                setSuccess(response.status == HttpStatusCode.OK)
                CoroutineScope(Dispatchers.Default).launch{
                    setMessage(response.body<List<String>>())
                }

            }
        }

        Dialog{
            this.open = isOpen
            this.onClose = { _, _ ->
                setIsOpen(false)
            }
//            DialogTitle{
//                + "Результат загрузки"
//            }
            DialogContent{
                Stack{
                    direction = responsive(StackDirection.column)
                    this.divider = Divider.create {
                        orientation = Orientation.horizontal
                        flexItem = true
                    }
                    asDynamic().spacing = 2
                    sx{
                        alignItems = AlignItems.center
                        border = 2.px
                    }


                    if (success == true) {
                        CheckCircle{
                            fontSize = SvgIconSize.large
                            color = SvgIconColor.success
                        }
                    } else {
                        ErrorOutline{
                            fontSize = SvgIconSize.large
                            color = SvgIconColor.error
                        }
                    }

                    DialogContentText{
                        message.forEach {
                            ListItemText{
                                + it
                            }
                        }
                    }
                }

            }
            DialogActions{
                Button {
                    color = ButtonColor.secondary
                    variant = ButtonVariant.outlined
                    onClick = {
                        setIsOpen(false)
                    }
                    +"Закрыть"
                }
            }
        }
        + props.children
    }
}
